import React from "react";
import LoginLayout from "../components/LoginLayout";
import { AccessCodeForm } from "../features/auth";

const AccessCodePage = () => {
  return (
    <LoginLayout>
      <AccessCodeForm />
    </LoginLayout>
  );
};

export default AccessCodePage;
